import { useDispatch, useSelector } from "react-redux";
import LoginModel from "../../components/Models/LoginModel";
import { RootState, AppDispatch } from "../../store";
import { setErrorMessage } from "../../pages/auth/otpSlice";
import Otp from "../../pages/auth/otp";
import { useEffect, useState } from "react";
import { inputFieldContent } from "../inputfields/InputFieldContent";
import useTranslation from "../CustomHooks/useTranslation";

interface OTPVerificationProps {
  handleSubmitOTP: () => void;
  instructionText: string;
  handleClickResendOTP: (id: string, resend : boolean) => void;
  handleClose: () => void;
  otp_id: string;
}
export default function OTPVerification({
  handleSubmitOTP,
  handleClickResendOTP,
  otp_id,
  instructionText,
  handleClose,
}: OTPVerificationProps) {
  const dispatch = useDispatch<AppDispatch>();
  const { loading } = useSelector(
    (state: RootState) => state.login
  );
  const {otp} = useSelector((state: any) => state.otp);
  const [testID, setTestIdD] = useState('')
  const { translate } = useTranslation(inputFieldContent);
  const handleSubmitOTPButton = async () => {
    const fullOtp = otp.join(""); // Join OTP array into a string
    if (fullOtp.length === 6) {
      try {
          handleSubmitOTP();
      } catch (error: any) {
        console.error("Error verifying OTP:", error);
        dispatch(setErrorMessage("Invalid OTP. Please try again."));
      }
    } else {
      dispatch(setErrorMessage("Invalid OTP. Please try again."));
    }
  };
  const handleResendOtpButton = () => {
    handleClickResendOTP(otp_id, true)
  }
  useEffect(() => {
    setTestIdD(`${otp_id}_verify_model`)
  }, [otp_id])
  return (
    <LoginModel
      instruction={instructionText}
      heading={translate("OTP Verification")}
      handleSubmit={handleSubmitOTPButton}
      loading={loading}
      buttonName={translate("Verify")}
      buttonClassName={"w-[410px]"}
      handleResendOtp={handleResendOtpButton}
      mainImg="otp_icon"
      testId="verify_otp_model"
      handleClose={handleClose}
    >
      <Otp />
    </LoginModel>
  );
}